import { apiSource, isMockApiSource } from "./Realty/config/apiSource";
import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App";
import "./index.css";

async function enableMocking() {
  // apiSource can resolve to "mock" only on a loopback hostname, so this is
  // also safe for a production build served locally for QA.
  const shouldEnableMocking = isMockApiSource;

  if (shouldEnableMocking) {
    const { worker } = await import("./mocks/browser.js");

    return worker.start({
      serviceWorker: {
        url: "/mockServiceWorker.js",
      },
      onUnhandledRequest: "bypass",
    });
  }

  return Promise.resolve();
}

const rootElement = ReactDOM.createRoot(document.getElementById("root"));

enableMocking().then(() => {
  if (process.env.NODE_ENV === "development") {
    console.info(`[API] data source: ${apiSource}`);
  }
  rootElement.render(<App />);
});

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// );
